import React, { useContext } from "react";
import ModalMain from "../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import userContext from "../../../../context/users/UserContext";
import { USERTYPES } from "../../../../constants/Constants";

const ShortcutKeyModal = ({ isSharedStudyViewer }) => {

    const {setShowShortcutModal} = useContext(studyviewerContext);

    let DefaultButtonList = [
        {
          title: t("button.close"),
          onclick: () => {
            setShowShortcutModal(false);
          },
        },
      ];

    const modalDetails = {
        header: (
          <ModalHeader
            updatedModal={true}
            heading="Shortcut Keys"
            handleCancel={() =>  setShowShortcutModal(false)}
          />
        ),
        body: <ShortcutKeyModalBody isSharedStudyViewer={isSharedStudyViewer}/>,
        footer: (
          <ModalFooter
            PrimaryButtonList={[]}
            DefaultButtonList={DefaultButtonList}
          />
        ),
        width: "700px",
      };
    
      return (
        <>
          <ModalMain
            updatedModal={true}
            modalDetails={modalDetails}
            showModal={true}
          />
        </>
      );
}

export default ShortcutKeyModal;

const ShortcutKeyModalBody = ({ isSharedStudyViewer }) => {

    const { getThemeColor,themeName,getScrollBarStyleForTheme } = useContext(themeContext);
    const {roles, privilegedFirmDoctor}=useContext(userContext);

    const containerStyle = {
        padding: '20px',
        lineHeight: '1.6',
        color: '#dcdcdc',
        maxHeight: '70vh',
        overflow: 'auto'
    };

    const headingStyle = {
        color: '#f5f5f5',
        marginBottom: '20px',
    };

    const sectionHeadingStyle = {
        color: '#ff9800',
        marginTop: '20px',
    };

    const codeStyle = {
        backgroundColor: getThemeColor("action-details-background"),
        padding: '10px',
        border: '1px solid #444',
        borderRadius: '5px',
        fontSize: '15px',
        marginBottom: '10px',
        color: getThemeColor("primary-color")
    };

    const keyStyle = {
      fontFamily: 'monospace',
      backgroundColor: '#444',
      padding: '2px 4px',
      borderRadius: '3px',
      color: '#ffcc00',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '20px',
  };

  const thStyle = {
      textAlign: 'left',
      color: '#ffcc00',
      paddingBottom: '10px',
      borderBottom: '2px solid #444',
  };

  const tdKeyStyle = {
      width: '20%',
      padding: '10px',
      border: '1px solid #444',
      backgroundColor: getThemeColor("action-details-background"),
      borderRadius: '5px',
      fontSize: '15px',
      color: themeName === "light"?"black":'#ffcc00',
      fontFamily: 'monospace',
  };

  const tdValueStyle = {
      width: '80%',
      padding: '10px',
      border: '1px solid #444',
      backgroundColor: getThemeColor("action-details-background"),
      borderRadius: '5px',
      fontSize: '15px',
      color:getThemeColor("primary-color"),
  };

    return (
      <div style={containerStyle} className={getScrollBarStyleForTheme(themeName,"common-modal-scroll")}>
      <h2 style={sectionHeadingStyle}>Navigation Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>s</code></td>
                  <td style={tdValueStyle}>Open Series</td>
              </tr>
              {!isSharedStudyViewer &&
                roles?.[0]?.includes &&
                (!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) && (
                    <tr>
                    <td style={tdKeyStyle}><code>r</code></td>
                    <td style={tdValueStyle}>Open Report</td>
                    </tr>
                )}
              <tr>
                  <td style={tdKeyStyle}><code>Up Arrow</code></td>
                  <td style={tdValueStyle}>Previous Image on Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Down Arrow</code></td>
                  <td style={tdValueStyle}>Next Image on Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Right Arrow</code></td>
                  <td style={tdValueStyle}>Change Series to Next Series in Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>Left Arrow</code></td>
                  <td style={tdValueStyle}>Change Series to Previous Series in Active Viewport</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>i</code></td>
                  <td style={tdValueStyle}>Invert Image</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>h</code></td>
                  <td style={tdValueStyle}>Horizontal Flip</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>v</code></td>
                  <td style={tdValueStyle}>Vertical Flip</td>
              </tr>
          </tbody>
      </table>
      <h2 style={sectionHeadingStyle}>Measurement Tool Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>𝑙</code></td>
                  <td style={tdValueStyle}>Length</td>
              </tr>
              <tr>
                 <td style={tdKeyStyle}><code>e</code></td>
                 <td style={tdValueStyle}>Ellipse</td>
              </tr>
          </tbody>
      </table>   
      <h2 style={sectionHeadingStyle}>Window Level Tools Shortcuts</h2>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>0</code></td>
                  <td style={tdValueStyle}>Reset WW/WC</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>l</code></td>
                  <td style={tdValueStyle}>Length</td>
              </tr>
              <tr>
                 <td style={tdKeyStyle}><code>e</code></td>
                 <td style={tdValueStyle}>Ellipse</td>
              </tr>
          </tbody>
      </table>

      <h3 style={sectionHeadingStyle}>CT/MR Specific Shortcuts</h3>
      <table style={tableStyle}>
          <tbody>
              <tr>
                  <td style={tdKeyStyle}><code>1</code></td>
                  <td style={tdValueStyle}>Abdomen</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>2</code></td>
                  <td style={tdValueStyle}>Angio</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>3</code></td>
                  <td style={tdValueStyle}>Bone</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>4</code></td>
                  <td style={tdValueStyle}>Brain</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>5</code></td>
                  <td style={tdValueStyle}>Chest</td>
              </tr>
              <tr>
                  <td style={tdKeyStyle}><code>6</code></td>
                  <td style={tdValueStyle}>Lungs</td>
              </tr>
          </tbody>
      </table>
  </div>
    );
}